import { Flex, Heading } from '@chakra-ui/layout';
import { IconStudioDisplay } from 'central-icons/IconStudioDisplay';

import { SankeyError } from '@revelio/assets';
import { useChartTheme } from '@revelio/replots';

import { useBrand } from '../shared/branding/brand-provider';
import styles from './MobileUnsupportedPage.module.css';

export const MobileUnsupportedPage = () => {
  const brand = useBrand();
  const BrandFullLogo = brand.logos.fullLogo;
  const { isNewTheme } = useChartTheme();

  if (isNewTheme) {
    return (
      <div className={styles.page}>
        <div className={styles.content}>
          <BrandFullLogo className={styles.logo} />
          <h1 className={styles.title}>
            This experience is best on larger screens
          </h1>
          <p className={styles.description}>
            At this time, Revelio Labs is best experienced on desktop and larger
            screens to give you the full power of our analytics platform.
          </p>
          <svg
            className={styles.glyph}
            viewBox="0 0 131 112"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <rect
              x="3"
              y="3"
              width="125"
              height="86"
              stroke="currentColor"
              strokeWidth="6"
            />
            <path d="M48 89v17h35V89" stroke="currentColor" strokeWidth="6" />
          </svg>
          <div className={styles.card}>
            <IconStudioDisplay size={34} className={styles.cardIcon} />
            <div className={styles.cardText}>
              <p className={styles.cardTitle}>For the best experience</p>
              <p className={styles.cardBody}>
                Please visit us on a laptop or desktop computer.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <Flex
      direction="row"
      align="center"
      justify="center"
      minH="100vh"
      textAlign="center"
      bg="#F1F5F9"
      py="12"
      px={{ base: '4', lg: '8' }}
    >
      <Flex maxW="md" mx="auto" flexDirection="column">
        <BrandFullLogo mx="auto" h="39" mb={{ base: '4', md: '6' }} />
        <Heading
          textAlign="center"
          size="xl"
          fontWeight="extrabold"
          color="text.primary"
          mb="6"
        >
          Please use a larger screen for the best experience to meet your
          workforce analytics needs.
        </Heading>
        <SankeyError height="192px" />
      </Flex>
    </Flex>
  );
};
